<template>
  <div class="box ml-3">
    <div class="box-tittel">
      <h1 class="text-center">{{this.tittle}}</h1>
    </div>
    <br />
    <div class="box-100">
      <div class="box-list">
        <TasListComponent :taskList="$store.getters.getTasks" />
      </div>
      <div class="box-form">
        <TaskFormComponent
          :task="$store.getters.getTaskSelected"
          :values="$store.getters.getSubtaskToTaskSelected"
          :update="$store.getters.getIsTaskUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script >
import TasListComponent from "./../components/tasks/TaskList.vue";
import TaskFormComponent from "./../components/tasks/TaskForm.vue";


export default {
  name: "Categorias",
  components: {
    TasListComponent,
    TaskFormComponent
  },
  data() {
    return {
      tittle: "Categorias"
    };
  },  
};
</script>